/**
 * Black or white, whichever reads better on the given background (WCAG relative luminance).
 * Returns null for a missing or unparseable colour so the stylesheet default applies.
 */
export function readableTextColor(background: string | null | undefined): string | null {
  const rgb = parseColor(background);
  if (!rgb) {
    return null;
  }
  const [r, g, b] = rgb.map(channel => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  // contrast against white vs. black: (1.05) / (L + 0.05) vs (L + 0.05) / 0.05
  return 1.05 / (luminance + 0.05) >= (luminance + 0.05) / 0.05 ? '#ffffff' : '#000000';
}

function parseColor(value: string | null | undefined): number[] | null {
  const color = (value || '').trim().toLowerCase();
  const hex = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})([0-9a-f]{2})?$/);
  if (hex) {
    const digits = hex[1].length === 3 ? hex[1].split('').map(d => d + d).join('') : hex[1];
    return [0, 2, 4].map(i => parseInt(digits.substring(i, i + 2), 16));
  }
  const rgb = color.match(/^rgba?\(\s*(\d{1,3})[\s,]+(\d{1,3})[\s,]+(\d{1,3})/);
  return rgb ? [rgb[1], rgb[2], rgb[3]].map(Number) : null;
}
